import React from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Text } from '@chakra-ui/react';
interface UnsubscribeModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const UnsubscribeModal = ({
  isOpen,
  onClose
}: UnsubscribeModalProps) => {
  return <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent bg="gray.800" border="1px" borderColor="gray.700">
        <ModalHeader color="white">Confirm Unsubscribe</ModalHeader>
        <ModalBody>
          <Text color="gray.300">
            Are you sure you want to unsubscribe? This will disable all active
            store protections immediately.
          </Text>
        </ModalBody>
        <ModalFooter gap={2}>
          <Button variant="ghost" onClick={onClose} color="gray.300">
            Cancel
          </Button>
          <Button bg="red.500" color="white" _hover={{
          bg: 'red.600',
          boxShadow: '0 0 20px rgba(229, 62, 62, 0.5)'
        }}>
            Unsubscribe
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>;
};